import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    fichier: [],
    uploadedFile: null,
});

const getters = {
    all: state => state.all,
    one: state => state.one,
    fichier: state => state.fichier,
    uploadedFile: state => state.uploadedFile,

};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    }, 
    SET_FICHIER: (state, obj) => {
        state.fichier = obj;
    },
    SET_UPLOADED_FILE: (state, obj) => {
        state.uploadedFile = obj;
    },
}

const actions = {
    async uploadFichier({ commit }, { typeId, payload }) {
        try {
          const data  = await client.post(`fichier/add/${typeId}`, payload, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          commit('SET_FICHIER', data);
          return data;
      
        } catch (error) {
            console.error('Erreur lors de l\'ajout du document :', error);
          throw error;
        }
    },
    async downloadFichier({ commit, state }, { fichierId, timeout = 0, onDownloadProgress } = {}) {
        try {
            if (fichierId == null || fichierId === '' || fichierId === 'undefined') {
                throw new Error('Identifiant fichier manquant');
            }
            const response = await client.get(`fichier/download/${fichierId}`, {
                responseType: 'blob', // Spécifier que la réponse doit être traitée comme un blob (fichier binaire)
                timeout,
                onDownloadProgress
            });

            if (state.uploadedFile && typeof state.uploadedFile === 'string' && state.uploadedFile.startsWith('blob:')) {
                URL.revokeObjectURL(state.uploadedFile);
            }
            const fileUrl = URL.createObjectURL(response.data); // Convertir le blob en URL
            commit('SET_UPLOADED_FILE', fileUrl);
    
            return fileUrl;
        } catch (error) {
            console.error('Erreur lors du téléchargement du fichier:', error);
            throw error; 
        }
    },
    async downloadCertificatEn(_ctx, { fichierId, matricule, timeout = 120000 } = {}) {
        try {
            const response = await client.get(`fichier/download/${fichierId}/certificat-en`, {
                responseType: 'blob',
                timeout,
            });
            const fileName = `CERTIFICATE-${matricule || 'OECCA'}-EN.pdf`;
            const fileUrl = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => URL.revokeObjectURL(fileUrl), 1000);
            return fileUrl;
        } catch (error) {
            console.error('Erreur lors du téléchargement du certificat en anglais:', error);
            throw error;
        }
    },
    
    
    
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};